import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementPredictionFiltersPreviewAppGroupIdResult = objectOf({
  build_may_fail: boolean,
  build_will_fail: boolean,
  description: string,
  description_array: objectOf({
    universe_filters: arrayOf(arrayOf(string)),
    condition_filters: arrayOf(arrayOf(string)),
  }),
  distributed: boolean,
  look_back_non_target_users: number,
  look_back_users: number,
  min_look_back_non_target_users: number,
  min_look_back_users: number,
  summary_statistics: objectOf({
    estimated: boolean,
    total_app_users: number,
    total_segment_users: number,
    total_segment_users_margin_of_error: number,
  }),
  training_size_req_met: boolean,
  warning_threshold_size_req_met: boolean,
  invalid_filter_state_for_look_back: boolean,
});
